"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleInterestLoanConversionType = void 0;
var SimpleInterestLoanConversionType;
(function (SimpleInterestLoanConversionType) {
    SimpleInterestLoanConversionType["constantPayment"] = "constantPayment";
    SimpleInterestLoanConversionType["constantTerm"] = "constantTerm";
})(SimpleInterestLoanConversionType || (exports.SimpleInterestLoanConversionType = SimpleInterestLoanConversionType = {}));
